import Feature from "../models/feature";
import ProjectInfo from "../models/projectInfo";

const isFeatureEnabled = (feature: Feature, project: ProjectInfo) => {
  if (feature === Feature.SummaryCharts) {
    return project.hasSummaryCharts;
  }

  if (feature === Feature.Charts) {
    return project.hasCharts;
  }

  if (feature === Feature.AutoProgressiveImageLoading) {
    return project.autoProgressiveImageLoading;
  }

  return false;
};

const featureService = {
  isFeatureEnabled,
};

export default featureService;
